module.exports = __webpack_public_path__ + "static/background-hero-athletico-paranaense-lg-046de24fe429465142e5195e5ca124bb.jpg";